import { createStore, applyMiddleware, compose } from 'redux';
import reducer from './reducers/cartReducer';

function configureStoreBase(shouldAddDebug, initialState, arrMiddlewares, reducerRoot) {
  const middleware = arrMiddlewares.concat([]);
  const store = createStore(
    reducerRoot,
    initialState,
    compose(applyMiddleware(...middleware),
      (shouldAddDebug && window.devToolsExtension) ? window.devToolsExtension() : f => f));
  return store;
}

export default (shouldAddDebug, initialState = {}, arrMiddlewares = [], history) =>
  configureStoreBase(shouldAddDebug, initialState, arrMiddlewares, reducer(history));
